"use client";
import { Input } from "antd";
import type { InputProps } from "antd";

function AppInput(props: InputProps) {
  return <Input {...props} />;
}

export { AppInput };
